// frontend/src/pages/ProfilePage.jsx
import React from 'react';
import ProfileForm from '../components/profile/ProfileForm';
import NotificationPreferences from '../components/profile/NotificationPreferences';

const ProfilePage = () => {
  return (
    <div className="container mx-auto py-6 px-4">
      <h1 className="text-3xl font-bold mb-6">Mon compte</h1>
      
      <div className="space-y-8">
        {/* Formulaire de profil existant */}
        <ProfileForm />
        
        {/* Nouveau composant pour les préférences de notification */}
        <NotificationPreferences />
      </div>
    </div>
  );
};

export default ProfilePage;